/**
 * Resets scroll inside the embed checkout modal (booking-layout + modal container + iframe document).
 * Used when showing the final confirmation so the success screen is not left mid-scroll.
 */
export function scrollEmbedBookingLayoutToTop() {
  const bookingLayout = document.querySelector('#booking-page .booking-layout');

  if (bookingLayout) {
    bookingLayout.scrollTo({ top: 0, behavior: 'auto' });
  }

  const modalContainer = document.querySelector('#payment-modal .modal-container, #free-modal .modal-container');

  if (modalContainer) {
    modalContainer.scrollTo({ top: 0, behavior: 'auto' });
  }

  window.scrollTo(0, 0);
}
